import { gql } from 'apollo-angular';

const GET_ORGANIZATION_SYSTEMS = (MANAGE_GPO_ORG_USERS_CAT_5699?: boolean) => {
  return gql`
  query organizations {
    organizations(
      filter: {
        and: [
          {
            organizationType: { oneOf: ["Group", "HCO" ${
              MANAGE_GPO_ORG_USERS_CAT_5699 ? ', "GPO"' : ''
            }] }
            agreementStatus: { equals: "Active" }
          }
        ]
      }
    ) {
      id
      name
      organizationType
      address {
        id
        city
        state
        zip
      }
    }
  }
`;
};

export default GET_ORGANIZATION_SYSTEMS;
